import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";
import { TipSheetPreview } from "@/components/sheet/TipSheetPreview";

export const TipSheets = ({ date, reload }) => {
  const api = useApi();
  const [sheets, setSheets] = useState([]);
  useEffect(() => { api("get", `/sheets?date=${date}`).then((d) => setSheets(d.sheets)).catch(() => setSheets([])); }, [api, date, reload]);
  if (!sheets.length) return null;
  return (
    <section className="mb-8 space-y-4" data-testid="tip-sheets">
      <h2 className="text-lg font-bold">Tip sheets</h2>
      {sheets.map((s) => <div key={s.id} className="rounded-xl border border-white/5 bg-[#0B101D] p-3"><p className="font-semibold mb-2">{s.track}</p><TipSheetPreview sheet={s} /></div>)}
    </section>
  );
};
